import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import useCustomLogic from "../../../../Hooks/UseCustomLogic";

const FAQ = ({
  key = "",
  content = "",
  status = "",
  style = "",
  isLastItem = false,
  fromNavigation,
}) => {
  const { theme } = useCustomLogic();

  const handleStatusColor = (status) => {
    switch (status) {
      case "yes":
      case "Yes":
      case "yes proper":
      case "Yes Proper":
      case "YES":
        return "#82b54b";
      case "no":
      case "No":
      case "NO":
      case "yes not proper":
      case "Yes Not Proper":
      case "Not Required":
        return "#e04f1a";
      case "":
        return "";
      default:
        return "#3c90df";
    }
  };

  return (
    <Box key={key} display="flex" flexDirection="column" sx={{ width: "100%" }}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          marginTop: "10px",
          padding: "0px 10px",
        }}
      >
        <Typography variant="body4" sx={{ ...style }}>
          {content}
        </Typography>
        <Button
          sx={{
            fontSize: "20px",
            fontWeight: "bold",
            textAlign: "center",
            background: handleStatusColor(status),
            // background:
            //   status &&
            //   ( fromNavigation ? "#3c90df" : status == "yes" || status == "Yes" ? "#82b54b" : "#e04f1a"),
            // padding: "4px 36px",
            borderRadius: "0px",
            color: theme.palette.common.white,
            textTransform: "capitalize",
            width: "100px",
            "&:hover": {
              background: handleStatusColor(status),
              // (fromNavigation ? "#3c90df" : status == "yes" || status == "Yes" ? "#82b54b" : "#e04f1a"),
            },
          }}
        >
          {status == "not_required"
            ? "Not Required"
            : status == "yes_not_proper"
            ? "Yes Not Proper"
            : status == "yes_proper"
            ? "Yes Proper"
            : status == "no" || status == "No" || status == "NO"
            ? "No"
            : status}
        </Button>
      </Box>

      {!isLastItem && <Divider sx={{ backgroundColor: "e6ebf4", marginTop: "10px" }} />}
    </Box>
  );
};

export default FAQ;
